export default __webpack_public_path__ + "static/media/planet-earth-svgrepo-com.067d5054.svg";